import React from 'react';
import { TabbedOverviewPage, WhatItMeasuresSection } from '../components/OverviewSections.comp';

// Single page, no tab bar — per explicit instruction. This is the content
// the deck's own slide 5 screenshot actually shows (the A/B/C measure-card
// layout), not AssessmentSuiteSection's Children/Parents/Teachers/School
// leaders grid, which the deck never depicts visually. AssessmentSuiteSection
// stays defined in OverviewSections.comp.jsx (not deleted) in case it's
// wanted back later.
const AboutAssessmentPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'What Does the Child Online Safety (COS) Children Assessment Measure?',
                content: <WhatItMeasuresSection />,
            },
        ]}
    />
);

export default AboutAssessmentPage;
